import { Box, FormControl, TextField } from '@mui/material'
import { useForm } from 'hooks/useForm'
import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import RegularButton from 'components/CustomButtons/Button'
import {
  editWarehouse,
  createNewWarehouse,
} from 'redux/actions/warehousesCatalog/warehousesCatalogActions';
import { PERMISSIONS } from "router/permissions";
import { initialValues, requiredValues } from './inputValues'
import { AutocompleteComponent } from 'components/Autocomplete/AutocompleteComponent'

const { STORAGE_DEVICE_ID, STORAGE_AWS_UUID } = PERMISSIONS

const blue = '#0055aa'

export const FormWarehouseEdit = (props) => {
  const { handleClose } = props
  const { catalogWarehouseSelected, addMode, LicensesCRE } = useSelector(state => state.warehousesCatalog)
  const { token, rules } = useSelector(state => state.login)
  const { stationsList } = useSelector((state) => state.companies)
  const [creLicenseAvailable, setCreLicenseAvailable] = useState([])
  const {
    inputValues,
    handleInputOnChange,
    handleNewValues,
    setValues,
    errors,
    runValidates,
  } = useForm(initialValues, requiredValues)
  const dispatch = useDispatch()
  const { number, capacity, serialNumber, description, brand, uuidAws, deviceId, station, creLicense, expirationDate } = inputValues

  const handleSubmit = useCallback(() => {
    if (runValidates()) return;
    const newValues = {
      ...catalogWarehouseSelected,
      capacity: parseInt(capacity),
      number,
      serialNumber,
      brand,
      expirationDate,
      description,
      creLicense: creLicense.value,
      idStation: station.id,
      uuidAws,
      deviceId
    }
    if (addMode) {
      dispatch(createNewWarehouse(newValues, token))
      handleClose()
    } else {
      dispatch(editWarehouse(catalogWarehouseSelected.id, newValues, token))
      handleClose()
    }
  }, [runValidates, catalogWarehouseSelected, capacity, number, serialNumber, brand, expirationDate, description, creLicense, station, uuidAws, deviceId, addMode, dispatch, token, handleClose])

  const handleStation = useCallback((e) => {
    setValues({ ...e, creLicense: '' })
    if (e.station?.id) {
      setCreLicenseAvailable(LicensesCRE.filter(license => e.station?.id === license.id && !!license.value))
    }
  }, [setValues, LicensesCRE])

  const handleDate = useCallback((e) => {
    setValues({ expirationDate: e.value })
  }, [setValues])

  useEffect(() => {
    if (catalogWarehouseSelected) {
      handleNewValues({
        number: catalogWarehouseSelected.number,
        capacity: catalogWarehouseSelected.capacity,
        serialNumber: catalogWarehouseSelected.serialNumber,
        description: catalogWarehouseSelected.description,
        brand: catalogWarehouseSelected.brand,
        uuidAws: catalogWarehouseSelected.uuidAws,
        deviceId: catalogWarehouseSelected.deviceId,
        station: stationsList.find(stationValue => stationValue.id === catalogWarehouseSelected.idStation),
        creLicense: LicensesCRE.find(license => license.creLicense === catalogWarehouseSelected.creLicense),
        expirationDate: catalogWarehouseSelected.expirationDate
      })
      setCreLicenseAvailable(LicensesCRE.filter(license => catalogWarehouseSelected.idStation === license.id && !!license.value))
    }
  }, [catalogWarehouseSelected, LicensesCRE])

  return (
    <>
      <FormControl fullWidth style={{ display: 'flex', gap: 10, marginTop: 20 }} onSubmit={handleSubmit}>
        <AutocompleteComponent
          name="station"
          value={station}
          options={stationsList}
          label="Planta *"
          handleValues={handleStation}
          textFieldProps={{
            error: errors.station,
            helperText: errors.station,
          }}
        />
        <AutocompleteComponent
          name="creLicense"
          value={creLicense}
          options={creLicenseAvailable}
          label="Permiso CRE *"
          handleValues={setValues}
          textFieldProps={{
            error: errors.creLicense,
            helperText: errors.creLicense,
          }}
        />
        <TextField
          fullWidth
          type="text"
          label="Número Económico *"
          name="number"
          value={number}
          onChange={handleInputOnChange}
          variant="outlined"
          error={errors.number}
          helperText={errors.number}
        />
        <TextField
          type="number"
          label="Capacidad *"
          name="capacity"
          value={capacity}
          onChange={handleInputOnChange}
          variant="outlined"
          fullWidth
          error={errors.capacity}
          helperText={errors.capacity}
        />
        <TextField
          fullWidth
          type="text"
          label="Marca *"
          name="brand"
          value={brand}
          onChange={handleInputOnChange}
          variant="outlined"
          error={errors.brand}
          helperText={errors.brand}
        />
        <TextField
          fullWidth
          type="text"
          label="Serie *"
          name="serialNumber"
          value={serialNumber}
          onChange={handleInputOnChange}
          variant="outlined"
          error={errors.serialNumber}
          helperText={errors.serialNumber}
        />
        <TextField
          fullWidth
          type="text"
          label="Descripción *"
          name="description"
          value={description}
          onChange={handleInputOnChange}
          variant="outlined"
          error={errors.description}
          helperText={errors.description}
        />
        {
          rules.includes(STORAGE_DEVICE_ID) && (<TextField fullWidth type="text" label="Device ID" name="deviceId" value={deviceId} onChange={handleInputOnChange} variant="outlined" />)
        }
        {
          rules.includes(STORAGE_AWS_UUID) && (<TextField fullWidth type="text" label="AWS UUID" name="uuidAws" value={uuidAws} onChange={handleInputOnChange} variant="outlined" />)
        }
        <TextField
          label="Fecha de expiración"
          type={"date"}
          name="expirationDate"
          value={expirationDate}
          variant="outlined"
          fullWidth
          required
          onChange={({ target }) => handleDate(target)}
        />
        <Box sx={{ display: 'flex', justifyContent: "flex-end", gap: 8, }}>
          <RegularButton size="large" variant="contained" color="danger" onClick={handleClose} >Cancelar</RegularButton>
          <RegularButton
            size="large"
            variant="contained"
            style={{ backgroundColor: blue, color: 'white' }}
            onClick={handleSubmit}
          >
            {addMode ? 'Agregar' : 'Guardar'}
          </RegularButton>
        </Box>
      </FormControl>
    </>
  )
}
